var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from 'react';
import { getBadgeText } from './helper';
import "./style.scss";
import { playIconImage } from "../../../images/icon";
import pubsub from "@viewlift/pubsub";
var MonetisationBadge = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var plans = _a.plans, monetizationBadgeIdentifier = _a.monetizationBadgeIdentifier, trayItem = _a.trayItem, contentId = _a.contentId, _k = _a.overTheThumbnail, overTheThumbnail = _k === void 0 ? '' : _k, _l = _a.contentType, contentType = _l === void 0 ? '' : _l;
    var _m = __read(useState("Subscription"), 2), monetisationText = _m[0], setMonetisationText = _m[1];
    var _o = __read(useState(false), 2), updateUserState = _o[0], setUpdateUserState = _o[1];
    var ctaBgColour = (_f = (_e = (_d = (_c = (_b = window === null || window === void 0 ? void 0 : window.app_data) === null || _b === void 0 ? void 0 : _b.appcmsMain) === null || _c === void 0 ? void 0 : _c.brand) === null || _d === void 0 ? void 0 : _d.cta) === null || _e === void 0 ? void 0 : _e.primary) === null || _f === void 0 ? void 0 : _f.backgroundColor;
    var handleMonetisationText = function () { return __awaiter(void 0, void 0, void 0, function () {
        var text;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getBadgeText(monetizationBadgeIdentifier, plans, contentId)];
                case 1:
                    text = _a.sent();
                    setMonetisationText(text);
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        handleMonetisationText();
    }, [updateUserState]);
    useEffect(function () {
        // after login or subscription to handle race condition
        pubsub.subscribe("update-user-state", setUpdateUserState);
        return function () {
            pubsub.unsubscribe("update-user-state", setUpdateUserState);
        };
    }, []);
    var monetizationBadge = ((_j = (_h = (_g = window === null || window === void 0 ? void 0 : window.app_data) === null || _g === void 0 ? void 0 : _g.appcmsPlatform) === null || _h === void 0 ? void 0 : _h.images) === null || _j === void 0 ? void 0 : _j.monetizationBadge) || null;
    if (overTheThumbnail) {
        return (React.createElement(React.Fragment, null, monetizationBadgeIdentifier && monetisationText ?
            React.createElement("div", { className: "mb-over-the-thumbnail" },
                React.createElement("div", { className: 'badge-icon' },
                    " ",
                    monetizationBadge ? React.createElement("img", { src: monetizationBadge, alt: "", title: monetisationText }) : ''))
            :
                React.createElement(React.Fragment, null,
                    contentType === "VIDEO" && React.createElement("div", { className: "play-video-icon" }, playIconImage()),
                    contentType === "VIDEOPLAYLIST" && React.createElement("div", { className: "play-icon-playlist" }, playIconImage()))));
    }
    else {
        return (React.createElement(React.Fragment, null, monetizationBadgeIdentifier && monetisationText ?
            React.createElement("div", { className: "monetisation-badge" },
                React.createElement("div", { className: 'badge-icon' },
                    " ",
                    monetizationBadge ? React.createElement("img", { src: monetizationBadge, alt: "", title: monetisationText }) : ''),
                React.createElement("div", { style: trayItem, className: "monetisation-text" }, monetisationText))
            : React.createElement(React.Fragment, null)));
    }
};
export default MonetisationBadge;
